<template>
<layout-content>
  <template #toolbar>
    <el-date-picker
      v-model="query.date"
      type="month"
      format="yyyy年MM月"
      value-format="yyyy/MM"
      :clearable="false"
      :editable="false"
      :picker-options="pickerOptions"
      size="small"
      style="width:150px;"
      @change="onDateChange"
    />

    <el-button
      type="warning"
      icon="el-icon-document-add"
      size="small"
      style="margin-left:0;"
      @click="onCreateReportBtnClick"
    >生成</el-button>

    <el-button
      :disabled="!hasReport"
      type="primary"
      icon="el-icon-upload"
      size="small"
      style="margin-left:0;"
      @click="onSaveReportBtnClick"
    >保存</el-button>

    <el-button
      :disabled="!hasReport"
      type="success"
      icon="el-icon-download"
      size="small"
      style="margin-left:0;"
      @click="onExportReportBtnClick"
    >导出</el-button>
  </template>

  <template #body>
    <data-wrapper class="data-editor-wrapper">
      <div class="html-content-editor-wrapper">
        <div class="html-content-editor-inner">
          <vue-ueditor-wrap v-model="htmlContent" :config="editorConfig" class="html-content-editor" />
        </div>
      </div>
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseWordEditor from '../BaseWordEditor'
import LayoutContent from '../../../../components/Layout/Content'
import DataWrapper from '../../../../components/Data/DataWrapper'
import ReportRingChart from '../../../../components/ReportChart/ReportRingChart'
import ReportLineChart from '../../../../components/ReportChart/ReportLineChart'

export default {
  name: 'MonthReportLinGang',
  routeInfo: {
    label: '月报',
    path: '/data-management/report/month-report',
    icon: 'fa fa-users'
  },
  extends: BaseWordEditor,
  components: {ReportLineChart, ReportRingChart, DataWrapper, LayoutContent},
  computed: {
    apiKey: () => 'Report',
    pickerOptions: () => ({
      disabledDate: time => {
        const currentMonth = new Date()
        currentMonth.setDate(1)
        currentMonth.setHours(0, 0, 0, 0)
        return time >= currentMonth
      }
    }),
    monthVOCsSortData () {
      const {monthAnalyzeMap} = this.rawData

      if (monthAnalyzeMap) {
        const {keyComponentFactorMap, vocRankingList} = monthAnalyzeMap
        const keyComponentFactorDataList = vocRankingList.reduce((list, data) => {
          for (let factorId in data) {
            const factor = keyComponentFactorMap[factorId]
            const factorData = data[factorId]

            if (factor) {
              const {mir} = factor

              if (mir) {
                const {avg} = factorData

                list.push({
                  id: factorId,
                  name: factorData.name,
                  unit: factor.stdUnit,
                  value: avg,
                  iofp: Number((avg * mir).toFixed(3)),
                  mir
                })
              }
            }
          }

          return list
        }, [])

        return {
          avgSortList: [...keyComponentFactorDataList].sort((a, b) => b.value - a.value).slice(0, 10),
          ofpSortList: [...keyComponentFactorDataList].sort((a, b) => b.iofp - a.iofp).slice(0, 10)
        }
      }

      return null
    },
    yearVOCsSortData () {
      const {yearAnalyzeMap} = this.rawData

      if (yearAnalyzeMap) {
        const {keyComponentFactorMap, vocRankingList} = yearAnalyzeMap
        const keyComponentFactorDataList = vocRankingList.reduce((list, data) => {
          for (let factorId in data) {
            const factor = keyComponentFactorMap[factorId]
            const factorData = data[factorId]

            if (factor) {
              const {mir} = factor

              if (mir) {
                const {avg} = factorData

                list.push({
                  id: factorId,
                  name: factorData.name,
                  unit: factor.stdUnit,
                  value: avg,
                  iofp: Number((avg * mir).toFixed(3)),
                  mir
                })
              }
            }
          }

          return list
        }, [])

        return {
          avgSortList: [...keyComponentFactorDataList].sort((a, b) => b.value - a.value).slice(0, 10),
          ofpSortList: [...keyComponentFactorDataList].sort((a, b) => b.iofp - a.iofp).slice(0, 10)
        }
      }

      return null
    },
    chapterIndex () {
      const rawData = this.rawData || {}
      return ['monthSituation', 'monthAnalyzeMap', 'yearSituationMap', 'yearAnalyzeMap'].filter(prop => rawData[prop]).reduce((map, prop, index) => {
        map[prop] = index + 1
        return map
      }, {})
    }
  },
  methods: {
    getDate () {
      const date = new Date()
      date.setMonth(date.getMonth() - 1)
      return date.format('YYYY/MM')
    },
    setResponseResult (htmlContent) {
      this.oHtmlContent = htmlContent = this.getFormatHtmlContent(htmlContent)
      this.htmlContent = htmlContent.replace(/src="image\//g, `src="/report/${this.query.date}/image/`)
    },
    createReport () {
      this.changeLoadStatus(true)
      this.$api.WordReport[`create${this.apiKey}`](this.query)
        .then(({html, data}) => {
          this.setResponseResult(html)
          this.rawData = Object.freeze(data)
        }).catch(this.setErrorResult).finally(() => {
          this.changeLoadStatus(false)
        })
    },
    onDateChange () {
      this.changeLoadStatus(true)
      this.$api.WordReport[`get${this.apiKey}`](this.query)
        .then(this.setResponseResult).catch(this.setErrorResult).finally(() => {
          this.changeLoadStatus(false)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.report-table {
  font-size: 14px;
  min-width: 100%;
  border-color: #ebeef5;
  white-space: nowrap;

  th,
  td {
    padding: 3px 5px;
  }

  th {
    background-color: #f9f9f9;
  }

  tr {
    &:nth-child(2n) {
      /*background-color: #fafafa;*/
    }

    &:hover {
      background-color: #f5f7fa !important;
    }
  }
}

.data-editor-wrapper /deep/ .data-wrapper-body{
  flex-direction: row;
  justify-content: center;
}

.data-editor-wrapper /deep/ .html-content-editor-inner {
  width: 300mm;
}
</style>



// WEBPACK FOOTER //
// src/views/06Data-Management/03Report/01MonthReportLinGang/index.vue